module.exports = __webpack_public_path__ + "img/xp_coupon_25000.a4caa4fd.png";